import { useSelector } from 'react-redux';
import AuthSelectors from './AuthSelectors';

export default function useIsLoggedIn() {
    return useSelector(AuthSelectors.isLoggedIn);
}
